'use strict';

(function () {
  'use strict';

  angular.module('msUtility').filter('localDate', LocalDateFilter);
  LocalDateFilter.$inject = ['$filter'];

  /**
   * Java's LocalDate is serialized as an array of [YYYY, M, d].
   * Angular's 'date' filter expects an ISO 8601 string.
   *
   * This converts a LocalDate to the ISO format, and runs it through Angular's 'date' filter with the passed params.
   * This is expected to be used as a replacement for the 'date' filter, when using LocalDate
   */
  function LocalDateFilter($filter) {
    // Converts to a string of format 'yyyy-MM-dd'
    return function (date, format) {
      if (!date || date.length !== 3) {
        return date;
      }
      var year = date[0];
      var month = date[1] < 10 ? '0' + date[1] : date[1];
      var day = date[2] < 10 ? '0' + date[2] : date[2];
      return $filter('date')(year + '-' + month + '-' + day, format);
    };
  }
})();